import {
    AccessTime,
    CalendarToday,
    LocationOn,
    MedicalServices,
    MonitorHeart
} from "@mui/icons-material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./RescheduleAppointment.scss";

const RescheduleAppointment = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        newDate: "2026-02-24",
        startTime: "",
        endTime: "",
        reason: "",
        notifyPatient: true,
        notifyDoctor: true
    });

    return (


        <div className="content-wrapper">

            <div className="container-fluid p-4  min-vh-100">
                {/* Breadcrumb / Header */}

                <div className="page-header mb-4">
                    <div className="breadcrumb">
                        <h3 className="page-title">Reschedule Appointment</h3>
                        <span className="customize-breadcrumb">
                            <span className="home-icon">🏠</span>
                            <span className="separator"> - </span>
                            <span>Reschedule Appointment</span>

                        </span>
                    </div>
                </div>


                <div className="row">
                    {/* LEFT COLUMN: FORM */}
                    <div className="col-lg-8 ">
                        <div className="card border-0  p-4 custm-shadow " style={{ border: '1px solid #e9e9e9' }}>
                            <h5 className="fw-bold mb-1">Reschedule Information</h5>
                            <p className="text-muted small mb-4">Select a new date and time for the appointment.</p>

                            {/* Current Appointment Banner */}
                            <div className="alert alert-light border d-flex align-items-center mb-4" style={{ backgroundColor: "#f8f9fa" }}>
                                <CalendarToday className="text-muted me-3" />
                                <div>
                                    <div className="small fw-bold text-dark">Current Appointment</div>
                                    <div className="small text-muted">Saturday, July 15, 2023 at 10:00 AM - 10:30 AM</div>
                                </div>
                            </div>

                            {/* Date and Time Inputs */}
                            <div className="row g-3 mb-4">
                                <div className="col-md-6">
                                    <label className="form-label fw-semibold small">New Date</label>
                                    <input
                                        type="date"
                                        className="form-control form-control-lg"
                                        value={formData.newDate}
                                        onChange={(e) => setFormData({ ...formData, newDate: e.target.value })}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label fw-semibold small">Start Time</label>
                                    <div className="input-group">
                                        <input type="time" className="form-control form-control-lg border-end-0" />
                                        <span className="input-group-text bg-white border-start-0"><AccessTime className="text-muted fs-6" /></span>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label fw-semibold small">End Time</label>
                                    <div className="input-group">
                                        <input type="time" className="form-control form-control-lg border-end-0" />
                                        <span className="input-group-text bg-white border-start-0"><AccessTime className="text-muted fs-6" /></span>
                                    </div>
                                </div>
                            </div>

                            {/* Reason Field */}
                            <div className="mb-4">
                                <label className="form-label fw-semibold small">Reason for Rescheduling</label>
                                <textarea
                                    className="form-control"
                                    rows={5}
                                    placeholder="Please provide a reason for rescheduling this appointment"
                                    onChange={(e) => setFormData({ ...formData, reason: e.target.value })}
                                ></textarea>
                                <div className="form-text text-muted x-small">This information will be used for record-keeping purposes.</div>
                            </div>

                            {/* Notifications */}
                            <div className="mb-4">
                                <label className="form-label fw-semibold small d-block mb-2">Notifications</label>
                                <div className="form-check mb-2">
                                    <input className="form-check-input custm-check" type="checkbox" checked={formData.notifyPatient} id="notifPatient" />
                                    <label className="form-check-label small" htmlFor="notifPatient">Notify patient about the rescheduled appointment</label>
                                </div>
                                <div className="form-check">
                                    <input className="form-check-input custm-check" type="checkbox" checked={formData.notifyDoctor} id="notifDoctor" />
                                    <label className="form-check-label small" htmlFor="notifDoctor">Notify doctor about the rescheduled appointment</label>
                                </div>
                            </div>

                            {/* Buttons */}
                            <div className="d-flex justify-content-end gap-3 mt-2">
                                <button
                                    className="btn btn-outline-secondary-custom px-4"
                                    onClick={() => navigate(-1)}
                                    style={{ transition: 'all 0.2s ease' }}
                                >
                                    Cancel
                                </button>
                                <button className="btn btn-primary px-4 py-2 reschedule-button" >
                                    <CalendarToday className="fs-6 me-2" /> Reschedule Appointment
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* RIGHT COLUMN: DETAILS */}
                    <div className="col-lg-4 ">
                        <div className="card border-0 shadow-sm p-4 custm-shadow">
                            <h5 className="fw-bold mb-4">Appointment Details</h5>

                            {/* Patient */}
                            <div className="d-flex align-items-center mb-4">
                                <div className="rounded-circle   d-flex align-items-center justify-content-center me-3" style={{ width: 40, height: 40, color: "black", backgroundColor: "#ffe74d" }}>JS</div>
                                <div>
                                    <div className="small text-muted">Patient</div>
                                    <div className="fw-bold">John Smith</div>
                                </div>
                            </div>

                            {/* Doctor */}
                            <div className="d-flex align-items-center mb-4">
                                <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3" style={{ width: 40, height: 40 }}>SJ</div>
                                <div>
                                    <div className="small text-muted">Doctor</div>
                                    <div className="fw-bold">Dr. Sarah Johnson</div>
                                </div>
                            </div>

                            <hr className="my-4 text-muted" />

                            {/* Info List */}
                            <div className="d-flex align-items-start mb-4">
                                <AccessTime className="text-muted me-3" />
                                <div>
                                    <div className="small fw-bold">Duration</div>
                                    <div className="small text-muted">30 min</div>
                                </div>
                            </div>

                            <div className="d-flex align-items-start mb-4">
                                <MonitorHeart className="text-muted me-3" />
                                <div>
                                    <div className="small fw-bold">Type</div>
                                    <div className="small text-muted">Check-up</div>
                                </div>
                            </div>

                            <div className="d-flex align-items-start mb-4">
                                <MedicalServices className="text-muted me-3" />
                                <div>
                                    <div className="small fw-bold">Department</div>
                                    <div className="small text-muted">General Medicine</div>
                                </div>
                            </div>

                            <div className="d-flex align-items-start " style={{marginBottom:'35%'}}>
                                <LocationOn className="text-muted me-3" />
                                <div>
                                    <div className="small fw-bold">Room</div>
                                    <div className="small text-muted">Room 103</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RescheduleAppointment;